module.exports = (__webpack_require__(1369))("./node_modules/@studyportals/data-storage/dist/index.js");